import {useQuery} from '@tanstack/react-query';
import {CloudApi, Main, cloudMapper} from 'app/components/entities/cloud';

interface Args {
  code: string;
  teamId: string;
  enabled: boolean;
}

type State = 'disabled' | 'checking' | Main.CodeStatus;

export function useCheckCode({code, teamId, enabled}: Args): State {
  const {isSuccess, isLoading, data} = useQuery({
    queryKey: ['pairing', 'code', teamId, code],
    queryFn: async () => {
      return CloudApi.checkPairingCode(teamId, code);
    },
    enabled,
    cacheTime: 0,
  });

  if (!enabled) {
    return 'disabled';
  }

  if (isSuccess) {
    return cloudMapper.mapCodeStatus(data.status);
  }

  if (isLoading) {
    return 'checking';
  }

  return 'disabled';
}
